/**
 * preorder-variant.js
 * ------------------------------------------------------------------
 * バリエーション（サイズ）切り替え時に、選択中バリアントの在庫状況と
 * 商品モード(custom.stock_mode)に応じて購入ボタンの表示を出し分ける。
 *
 *   preorder(予約)      … 在庫あり→通常 / 在庫0でも継続販売設定なら「予約」ボタン＋お届け時期＋予約プロパティ
 *   discontinued(廃版)  … 常に購入不可(disabled)
 *   normal / soldout    … テーマ標準の表示に委ね、予約用の付与物のみ除去
 *
 * サーバー側 snippets/stock-status.liquid の判定ロジックをクライアントで再現する。
 * データは buy_buttons ブロックが出力する <script data-preorder-config> を参照。
 *
 * 【重要】テーマ標準のバリアント変更処理がボタンを再描画し、こちらの表示を
 * 上書きしてしまうため、MutationObserver でボタンの変化を監視し、その都度
 * 状態を再適用する（自分の書き込み中は監視を一時停止して無限ループを防ぐ）。
 * ※JS無効環境では初期表示（サーバーレンダリング）のまま。
 * ------------------------------------------------------------------
 */
(function () {
  'use strict';

  var configEl = document.querySelector('[data-preorder-config]');
  if (!configEl) return;

  var config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }
  var variants = config.variants || {};
  var labels = config.labels || {};

  var form = (configEl.closest && configEl.closest('form')) ||
             document.querySelector('form[action*="/cart/add"]');

  if (window.console && console.info) {
    console.info('[preorder-variant] init / mode=' + JSON.stringify(config.mode));
  }

  function getSelectedVariantId() {
    var input = (form && form.querySelector('[name="id"]')) ||
                document.querySelector('form [name="id"]');
    return input ? String(input.value) : null;
  }

  // stock-status.liquid と同じ判定
  function computeState(v) {
    if (!v) return 'normal';
    var mode = config.mode; // '' | 'preorder' | 'discontinued'
    if (mode === 'discontinued') {
      // 在庫あり → 通常販売 / 在庫0 → 廃版（購入不可）
      if (v.tracked && Number(v.qty) > 0) return 'normal';
      return 'discontinued';
    }
    if (mode === 'preorder') {
      if (v.tracked && Number(v.qty) > 0) return 'normal';
      if (v.available) return 'preorder';
      return 'soldout';
    }
    return v.available ? 'normal' : 'soldout';
  }

  function getButton() {
    return document.querySelector('.ProductForm__BuyButtons .ProductForm__AddToCart') ||
           document.querySelector('.ProductForm__AddToCart');
  }
  function getBuyContainer() {
    return document.querySelector('.ProductForm__BuyButtons');
  }

  function setLabel(btn, text, keepPrice) {
    if (keepPrice) {
      var span = btn.querySelector('span');
      if (span) { span.textContent = text; return; }
    }
    btn.textContent = text;
  }

  // お届け時期の通知は「常に1つだけ」に正規化する。
  // サーバー側(main-product.liquid)が初期描画した通知とJS生成分が二重表示されるのを防ぐため、
  // 既存の .ProductForm__PreorderNotice を再利用し、余分は削除する。
  function ensureNotice(container) {
    var list = document.querySelectorAll('.ProductForm__PreorderNotice');
    var notice = list.length ? list[0] : null;
    for (var i = 1; i < list.length; i++) {
      if (list[i].parentNode) list[i].parentNode.removeChild(list[i]);
    }
    if (!notice) {
      notice = document.createElement('p');
      notice.className = 'ProductForm__PreorderNotice Text--subdued';
      notice.setAttribute('data-js-preorder', 'true');
      if (container && container.parentNode) {
        container.parentNode.insertBefore(notice, container);
      }
    }
    return notice;
  }
  // 予約以外の状態では、サーバー側/JS生成を問わず全ての通知を除去する。
  function removeNotice() {
    var list = document.querySelectorAll('.ProductForm__PreorderNotice');
    for (var i = 0; i < list.length; i++) {
      if (list[i].parentNode) list[i].parentNode.removeChild(list[i]);
    }
  }

  // 予約プロパティ（_preorder / お届け時期）をフォームに同期。
  // サーバー側(main-product.liquid)が初期描画した hidden input（id無し）も対象にするため、
  // id ではなく name で検索し、常に「1つだけ」に正規化 or 全除去する。
  function inputsByName(name) {
    return form ? form.querySelectorAll('input[name="' + name + '"]') : [];
  }
  function removeInputsByName(name) {
    var list = inputsByName(name);
    for (var i = 0; i < list.length; i++) {
      if (list[i].parentNode) list[i].parentNode.removeChild(list[i]);
    }
  }
  function normalizeInput(name, value) {
    var list = inputsByName(name);
    if (list.length === 0) {
      var el = document.createElement('input');
      el.type = 'hidden';
      el.name = name;
      el.value = value;
      form.appendChild(el);
      return;
    }
    list[0].value = value;
    for (var i = 1; i < list.length; i++) {
      if (list[i].parentNode) list[i].parentNode.removeChild(list[i]);
    }
  }
  function setHiddenProps(on) {
    if (!form) return;
    var deliveryName = 'properties[' + config.deliveryLabel + ']';
    if (on) {
      normalizeInput('properties[_preorder]', 'true');
      if (config.delivery) {
        normalizeInput(deliveryName, config.delivery);
      } else {
        removeInputsByName(deliveryName);
      }
    } else {
      removeInputsByName('properties[_preorder]');
      removeInputsByName(deliveryName);
    }
  }

  // 動的決済ボタンの表示制御。JSが権限を持つのでサーバー注入の<style>は除去する。
  function togglePayment(hide) {
    var server = document.querySelector('style[id^="preorder-payment-hide-"]');
    if (server && server.parentNode) server.parentNode.removeChild(server);
    var el = document.getElementById('js-preorder-payment-hide');
    if (hide) {
      if (!el) {
        el = document.createElement('style');
        el.id = 'js-preorder-payment-hide';
        el.textContent = '.shopify-payment-button{display:none !important;}';
        document.head.appendChild(el);
      }
    } else if (el && el.parentNode) {
      el.parentNode.removeChild(el);
    }
  }

  function render(btn, container, state) {
    // 予約/廃版の付与物を一旦クリア
    btn.removeAttribute('data-preorder');
    btn.removeAttribute('data-discontinued');

    if (state === 'discontinued') {
      btn.setAttribute('data-discontinued', 'true');
      btn.setAttribute('disabled', 'disabled');
      btn.removeAttribute('data-action');
      setLabel(btn, labels.discontinued, false);
      removeNotice();
      setHiddenProps(false);
      togglePayment(true);
    } else if (state === 'preorder') {
      btn.setAttribute('data-preorder', 'true');
      btn.removeAttribute('disabled');
      btn.setAttribute('data-action', 'add-to-cart');
      setLabel(btn, labels.preorder, !!config.showPrice);
      if (config.delivery) {
        ensureNotice(container).textContent = config.deliveryLabel + '：' + config.delivery;
      } else {
        removeNotice();
      }
      setHiddenProps(true);
      togglePayment(true);
    } else if (state === 'soldout') {
      removeNotice();
      setHiddenProps(false);
      togglePayment(true);
    } else {
      // normal：テーマ標準（カートに入れる）に委ねる
      removeNotice();
      setHiddenProps(false);
      togglePayment(!config.showPayment);
    }
  }

  var observer = null;
  var scheduled = false;

  function observe() {
    if (!observer) return;
    // フォーム全体を監視（ボタン差し替え・テキスト変更・属性変更を捕捉）
    var target = form || getBuyContainer();
    if (target) {
      observer.observe(target, {
        childList: true,
        subtree: true,
        attributes: true,
        characterData: true
      });
    }
  }

  function apply() {
    var btn = getButton();
    if (!btn) return;
    var container = getBuyContainer();
    var vid = getSelectedVariantId();
    var v = vid ? variants[vid] : null;
    var state = computeState(v);

    // 監視を止めてからDOMを書き換え（自分の書き込みで監視が再帰しないように）→再開。
    // render は normal の場合ボタン文言をテーマ標準のまま残し、予約/廃版の付与物と
    // お届け時期通知だけを整理するため、毎回呼んでも安定する。
    if (observer) observer.disconnect();
    render(btn, container, state);
    if (observer) observe();
  }

  function scheduleApply() {
    if (scheduled) return;
    scheduled = true;
    var run = function () { scheduled = false; apply(); };
    if (window.requestAnimationFrame) window.requestAnimationFrame(run);
    else setTimeout(run, 16);
  }

  function init() {
    if (window.MutationObserver) {
      observer = new MutationObserver(function () { scheduleApply(); });
    }
    apply();
    observe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // バリアント変更イベント（custom.js 参照）。念のため複数タイミングで再適用。
  document.addEventListener('variant:changed', function () {
    scheduleApply();
    setTimeout(scheduleApply, 60);
    setTimeout(scheduleApply, 200);
  });
})();
